import Service from "../../../Services/index";

const ShoppingEmployee = {
    namespaced: true,
    state: {
        shoppingEmployeeList: [],
        shoppingEmployeeForm: [{
            employee: [],
            employee_id: null,
            amount: "",
            recorder: "",
            date: ""
        }],
        incomeEmployeeForm: [{
            employee: [],
            employee_id: null,
            amount: "",
            recorder: "",
            date: "",
            reason: "",
        }],
        form: {
            id: "",
            employee: "",
            employee_id: null,
            amount: "",
            recorder: "",
            date: ""
        },
        search: {
            employee: "",
            employee_id: "",
            date: ""
        },
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        },
    },
    mutations: {
        GET_SHOPPING_EMPLOYEE: (state, res) => {
            state.shoppingEmployeeList = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        GET_SHOPPING_EMPLOYEE_BY_ID: (state, res) => {
            state.form = {
                id: res.id,
                employee_id: res.employee_id,
                amount: res.amount,
                recorder: res.recorder,
                date: res.date,
                employee: res.employee,
            }
        },
        ADD_SHOPPING_DETAILS: (state) => {
            state.shoppingEmployeeForm = [
                ...state.shoppingEmployeeForm,
                {
                    employee: [],
                    employee_id: null,
                    amount: "",
                    recorder: "",
                    date: ""
                }
            ];
        },
        REMOVE_SHOPPING_DETAILS: (state, index) => {
            state.shoppingEmployeeForm = state.shoppingEmployeeForm.filter(
                (detail, itemIndex) => index !== itemIndex
            );
        },
        CLEAR_FORM_DATA: state => {
            state.shoppingEmployeeForm = [{
                employee: [],
                employee_id: null,
                amount: "",
                recorder: "",
                date: ""
            }]
        },
        CLEAR_FORM_DATA_INCOME: state => {
            state.incomeEmployeeForm = [{
                employee: [],
                employee_id: null,
                amount: "",
                recorder: "",
                date: "",
                reason: "",
            }]
        },
        CLEAR_SEARCH: (state) => {
            state.search = {
                employee: "",
                employee_id: "",
                date: ""
            }
        }
    },
    actions: {
        setShoppingEmployee({commit}, page = 1) {
            return Service.ShoppingEmployee.getShoppingEmployee(page).then(data => {
                commit("GET_SHOPPING_EMPLOYEE", data);
            })
        },
        saveShoppingEmployee({commit}, {id, data}) {
            if (!id) {
                return Service.ShoppingEmployee.createShoppingEmployee(data).then(res => {
                    //console.log("create");
                });
            } else {
                return Service.ShoppingEmployee.updateShoppingEmployee(id, data).then(res => {
                    //console.log("update");
                });
            }
        },
        saveOtherPayment({commit}, {data}) {
            return Service.ShoppingEmployee.saveOtherPayment(data);
        },
        saveOtherIncome({commit}, {data}) {
            return Service.ShoppingEmployee.saveOtherIncome(data);
        },
        clearFormData({commit}) {
            commit("CLEAR_FORM_DATA");
        },
        clearFormDataIncome({commit}) {
            commit("CLEAR_FORM_DATA_INCOME");
        },
        showShoppingEmployeeByID({commit}, id) {
            return Service.ShoppingEmployee.showShoppingEmployee(id).then(res => {
                commit("GET_SHOPPING_EMPLOYEE_BY_ID", res);
            })
        },
        delete({commit}, id) {
            return Service.ShoppingEmployee.deleteShoppingEmployee(id)
                .then(() => {
                    //console.log("delete shopping");
                })
                .catch(err => {
                    console.error(err);
                });
        },
        addShoppingDetails({commit}) {
            commit("ADD_SHOPPING_DETAILS");
        },
        removeShoppingDetails({commit}, index) {
            commit("REMOVE_SHOPPING_DETAILS", index)
        },
        search({commit}, data) {
            return Service.ShoppingEmployee.searchShoppingEmployee(data).then(res => {
                commit("GET_SHOPPING_EMPLOYEE", res)
            })
        },
        clearSearch({commit}) {
            commit("CLEAR_SEARCH");
        },
    }
};

export default ShoppingEmployee;
